import {withTranslation as translate} from 'react-i18next';

import Breadcrumbs from './breadcrumbs';

export default translate('navigation')(Breadcrumbs);
